import { TypeFormEnum } from '@zaoblako/web/shared/components/form-sidebar/enums/type.form.enum';
import { VoiceAssistantFormEnum } from '@zaoblako/shared/modules/ai/enums/voice-assistant-form.enum';
import type { FormSizeType } from '@zaoblako/web/shared/components/form-sidebar/models/form-state';

/** Form types by detected forms */
export const formTypes: Record<VoiceAssistantFormEnum, TypeFormEnum> = {
  [VoiceAssistantFormEnum.CONTRAGENT]: TypeFormEnum.CONTRAGENT,
  [VoiceAssistantFormEnum.CLIENT]: TypeFormEnum.CLIENT,
  [VoiceAssistantFormEnum.HD_TASK_TYPE]: TypeFormEnum.HELPDESK_TASK_TYPE,
  [VoiceAssistantFormEnum.CONTRACT]: TypeFormEnum.CONTRACT
};

/** Form titles by detected forms */
export const formTitles: Record<VoiceAssistantFormEnum, string> = {
  [VoiceAssistantFormEnum.CONTRAGENT]: 'Создание контрагента',
  [VoiceAssistantFormEnum.CLIENT]: 'Создание клиента',
  [VoiceAssistantFormEnum.HD_TASK_TYPE]: 'Создание типа заявки HD',
  [VoiceAssistantFormEnum.CONTRACT]: 'Создание договороа'
};

/** Form widths by detected forms */
export const formWidths: Partial<Record<VoiceAssistantFormEnum, FormSizeType>> = {
  [VoiceAssistantFormEnum.CONTRAGENT]: 'form-sidebar-small',
  [VoiceAssistantFormEnum.CLIENT]: 'form-sidebar-small',
  [VoiceAssistantFormEnum.HD_TASK_TYPE]: 'form-sidebar-small',
  [VoiceAssistantFormEnum.CONTRACT]: 'form-sidebar-small'
};
